import styled from '@emotion/styled'

import {
    breakpoint,
    breakpointMax,
    metrics,
    supports,
} from '@news-mono/component-library'

import { colors } from '@news-mono/component-library'
import { calcRem } from '@news-mono/component-library'
import { AppState } from '@news-mono/web-common'
import { useSelector } from 'react-redux'

export interface Props {
    isAmpRendered?: boolean
}

export const StyledBaseGrid = styled('div')(
    {
        margin: '0 auto',
        width: '100%',
        display: 'table', // Grid FallBack
        tableLayout: 'fixed', // Required for IE so content does not overflow

        // If grid is supported use css grid
    },
    supports('display: grid', {
        display: 'grid', // Override display: table
        gridTemplateColumns: '100%',

        // reset
        tableLayout: 'unset',
        [breakpoint('sm')]: {
            position: 'relative',
            overflow: 'visible',
            height: 'auto',
        },
    }),
)

export const StyledAmpContent = styled('div')<Props>({
    width: '100%',
    padding: calcRem(metrics.thewest.margins.md),
    margin: '0 auto',
    maxWidth: metrics.thewest.ampContentWidth,
})

interface StyledCellProps {
    hasBackground?: boolean
}

export const StyledCell = styled('div')<StyledCellProps>(
    ({ hasBackground }) => {
        return {
            display: 'block',
            backgroundColor: hasBackground
                ? colors.thewest.greyMouse
                : undefined,
        }
    },
)

export const StyledFooterCell = styled(StyledCell)(() => {
    const { isLive } = useSelector((state: AppState) => state.theWestLive)
    // DPT-1778 offset for west live based on scheduling
    const radioOffset = isLive ? 69 : undefined
    const stickyFooterAdUnitHeight = 60

    return {
        backgroundColor: colors.thewest.greyDolphin,
        paddingBottom: radioOffset && calcRem(radioOffset),
        // DPT-856: Spacing for sticky footer ad-unit
        [breakpointMax('sm')]: {
            paddingBottom: radioOffset
                ? calcRem(radioOffset + stickyFooterAdUnitHeight)
                : calcRem(stickyFooterAdUnitHeight),
        },
    }
})

export const StyledNestedGrid = styled('div')(
    {
        margin: '0 auto',
        width: '100%',

        display: 'table', // Grid FallBack
        tableLayout: 'fixed', // Required for IE so content does not overflow

        // If grid is supported use css grid
    },
    supports('display: grid', {
        display: 'grid', // Override display: table
        gridTemplateColumns: '100%',

        // reset
        tableLayout: 'unset',
    }),
)

export const StyledNestedCell = styled('div')({
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    maxWidth: metrics.thewest.siteMetrics.mainContentWidth,
    padding: `0 ${metrics.thewest.margins.outerMargin}px`,
    margin: '0 auto',
})
